import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { getMemberProfile, listLeaderboard } from "../lib/memberService";

export function LeaderboardPage() {
  const profile = useQuery({ queryKey: ["profile"], queryFn: getMemberProfile });
  const board = useQuery({ queryKey: ["leaderboard"], queryFn: listLeaderboard });
  return (
    <main className="standalone-shell">
      <header className="standalone-head">
        <Link className="brand" to="/app"><span className="brand-mark">H</span><span><b>THE HOUSE</b><small>WEEKLY BOARD</small></span></Link>
        <Link className="btn" to="/app">MISSION BOARD</Link>
      </header>
      <section className="leaderboard-hero">
        <span className="eyebrow">RESETS MONDAY 00:00 UTC</span>
        <h1>THE BOARD</h1>
        <p>Approved work only. The weekly top performers earn +250 XP.</p>
      </section>
      <section className="leaderboard-table">
        <div className="leaderboard-row header"><span>RANK</span><span>MEMBER</span><span>ROUTE</span><span>APPROVED</span><span>TRUST</span><span>WEEKLY XP</span></div>
        {(board.data ?? []).map((entry) => (
          <div className={`leaderboard-row ${entry.id === profile.data?.id ? "current" : ""}`} key={entry.id}>
            <strong className="leaderboard-position">{String(entry.position).padStart(2, "0")}</strong>
            <strong>{entry.handle}{entry.id === profile.data?.id && <small> YOU</small>}</strong>
            <span>{entry.route.toUpperCase()}</span>
            <span>{entry.approvedMissions}</span>
            <span>{entry.trustScore}</span>
            <b>+{entry.weeklyXp.toLocaleString()}</b>
          </div>
        ))}
      </section>
    </main>
  );
}
